import { ALLOWED_BRAND_TAG_DEFINITIONS } from "@faire/web-api--source/indigofair/settings/ALLOWED_BRAND_TAG_DEFINITIONS";

import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";

export const getSettingAllowedBrandTagDefinitions = (): string[] =>
  getSettingValueWithoutAssignment(ALLOWED_BRAND_TAG_DEFINITIONS, []);
